export default __webpack_public_path__ + "static/hotel-951399_1280-7a3de251ebbfacc8d3d2c2b8380be13b.png";